import { Util } from '@thinkwell/react.common'

export default function(appHost) {
  if (typeof window.thinkwell === 'undefined') window.thinkwell = {};

  window.thinkwell.config = {
    // Shopify App host
    host: `https://${appHost}`,

    // Base HTML element ID. Used to add html to DOM
    base_element_id: 'tw-elements',

    styles: []

  }

  window.thinkwell.lib = {
    inject: function inject(locationPath, route, selector, opts) {
      opts = opts || {}

      // Run only on the correct page
      if (location.href.indexOf(locationPath) >= 0 && $(selector).length == 1) {
        var url = `${thinkwell.config.host}${route}?shop_name=${Shopify.shop}`;
        var contentClass = route.split("/").pop()

        var $shopify_data = $('#shopify_data');
        if ($shopify_data.length == 1) {
          $.each($shopify_data[0].attributes, function() {
            if (this.specified) {
              url = `${url}&${this.name}=${encodeURIComponent(this.value)}`;
            }
          });
        }

        var $thinkwell_content = $(`.thinkwell-content.${contentClass}`);
        if(!$thinkwell_content || !$thinkwell_content.length) {
          $thinkwell_content = $('<div class="thinkwell-content ' + contentClass + '" style="min-height:180px"><div class="content"></div><div class="row large"><div class="columns">' + (opts.withoutLoader ? '' : '<div class="loader"></div>') + '</div></div></div>');

          if (opts.replaceWith) {
            $(selector).replaceWith($thinkwell_content);
          } else if (opts.prepend) {
            $(selector).prepend($thinkwell_content);
          } else if (opts.before) {
            $(selector).before($thinkwell_content);
          } else {
            $(selector).html($thinkwell_content);
          }
        }

        if (opts.params) {
          for (var i = 0 ; i < opts.params.length; i++) {
            var param = opts.params[i];
            var value = Util.getParam(window.location.href, param);
            if (value) {
              url = `${url}&${param}=${value}`;
            }
          }
        }

        if (opts.query) {
          url = `${url}&${opts.query}`;
        }

        $.ajax({
          url: url,
          cache: false,
          crossDomain: true,
          xhrFields: {
             withCredentials: true
          },
          success: function (data, status) {
            if (data.status === 'redirect') {
              Util.redirect(data);
            } else if (data.status == 'error') {
              $('.loader').hide();
              window.scrollTo(0, 0);
              window.thinkwell.$tw_flash_message.text(data.message).slideUp().slideDown();
            } else {
              $thinkwell_content.find('.content').html(data);
              typeof(ReactRailsUJS) != 'undefined' && ReactRailsUJS.mountComponents();
            }
          },
          error: function() {
            $('.loader').hide();
          }
        });
      }
    }
  }

  // Insert styles
  for (var i = 0; i < window.thinkwell.config.styles.length; i++) {
    var cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = window.thinkwell.config.host + window.thinkwell.config.styles[i];
    document.head.appendChild(cssLink);
  }

  $(document).ready(function() {
    if ($('#'+thinkwell.config.base_element_id).length === 0) {
      $('body').append('<div id="' + thinkwell.config.base_element_id + '"></div>');
    }

    window.thinkwell.$tw_elements = $('#'+thinkwell.config.base_element_id);

  });
}
